import { render, staticRenderFns } from "./fechas-tutorias.vue?vue&type=template&id=cf86b254&scoped=true&"
import script from "./fechas-tutorias.component.ts?vue&type=script&lang=ts&"
export * from "./fechas-tutorias.component.ts?vue&type=script&lang=ts&"
import style0 from "./fechas-tutorias.vue?vue&type=style&index=0&id=cf86b254&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf86b254",
  null
  
)

export default component.exports